var $window, dealList, expChangeToWebp, fixiOS5, getElementPositions, getFold, getImagesToLoad, getTouchDealCardHeight, progressiveLoad, setTouchImageDimensions, setWebpSetting, touchDealCardHeight, unbindLazyloaderEvent, withinViewport;

touchDealCardHeight = dealList = void 0;

$window = $(window);


/*
 * With IOS5 force loading images when navigating with back button.
 * Non optimal workaround.
 *
 * @param {Array} allLazyImages[] - All images to be lazyloaded
 */

fixiOS5 = function(allLazyImages) {
  if (/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)) {
    return $window.one('pageshow', function(event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        return $(allLazyImages).trigger('appear');
      }
    });
  }
};


/*
 * Determine image positions within the document
 *
 * @param   {Array} images[] - Array with images nodes
 * @returns {Array} pos[]    - Array containing the current images position in the document
 */

getElementPositions = function(images) {
  var img, left, pos, ref, right, top;
  pos = [];
  images = images.slice();
  while ((img = images.shift())) {
    ref = img.getBoundingClientRect(), top = ref.top, left = ref.left, right = ref.right;
    pos.push({
      left: left,
      top: top,
      right: right
    });
  }
  return pos;
};


/*
 * Returns the top/bottom coordinate of the visible viewport in doc coords
 *
 * @returns {Object}
 */

getFold = function() {
  return {
    height: window.innerHeight || $window.height(),
    width: window.innerWidth || $window.width()
  };
};


/*
 * Filter out the `images` that are visible, but not yet loaded
 *
 * @param   {Array} images[] - Images to lazyload
 * @returns {Array} toLoad[] - Images that haven't been loaded
 */

getImagesToLoad = function(images) {
  var img, toLoad;
  toLoad = [];
  images = images.slice();
  while ((img = images.shift())) {
    if (!img.loaded && img.offsetHeight) {
      toLoad.push(img);
    }
  }
  return toLoad;
};


/*
 * Returns potential deal card height
 *
 * @returns {Number} height - Deal card height
 */

getTouchDealCardHeight = function() {
  var height;
  height = 0;
  if (typeof Touch !== "undefined" && Touch !== null ? Touch.Utils.getViewportInformation : void 0) {
    height = Touch.Utils.getViewportInformation({
      offset: dealList[0].offsetLeft * 2
    }).dcH;
  }
  return height;
};

expChangeToWebp = function(url, settings) {
  if (settings.webp && url.match(/(img(\d?).grouponcdn.com).*(jpg|png)$/)) {
    Finch.experiment('LS-2718-webp-images', {
      Control: function() {},
      Treatment: function() {
        return url = url.replace(/(q\d+)?(.jpg|.png)$/, '.webp');
      }
    });
  }
  return url;
};


/*
 * Sets html height attribute to touch dealcard images to speed up their rendering
 *
 * @param {Array} collection[] - Collection of images nodes
 */

setTouchImageDimensions = function(collection) {
  var i, img, len;
  window.removeEventListener('load', setTouchImageDimensions);
  if (!(dealList = document.querySelectorAll('.t-deals')).length) {
    return;
  }
  if ((touchDealCardHeight = getTouchDealCardHeight())) {
    for (i = 0, len = collection.length; i < len; i++) {
      img = collection[i];
      if (img.parentNode.parentNode.parentNode.className.match(/t-deals/)) {
        img.height = touchDealCardHeight;
      }
    }
  }
};

setWebpSetting = function(settings, override) {
  var ref;
  settings.webp = override != null ? override : (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref = Modernizr.webp) != null ? ref.valueOf() : void 0 : void 0) || $('html').hasClass('webp') || false;
  return settings;
};


/*
 * Unbind the lazyloader event
 */

unbindLazyloaderEvent = function(settings) {
  if (settings.performantScroll) {
    $(settings.container).off(settings.event);
  }
};


/*
 * Determine if an images is within the viewport + threshold
 *
 * @param   {Object}  fold      - Viewport information
 * @param   {Object}  imgPos    - Image information
 * @param   {Number}  threshold - Threshold to consider loading images within
 * @returns {Boolean}
 */

withinViewport = function(fold, imgPos, threshold) {
  var left, right, top;
  left = imgPos.left, top = imgPos.top, right = imgPos.right;
  if (top <= -threshold) {
    return false;
  }
  if (top >= fold.height + threshold) {
    return false;
  }
  if (left <= -threshold) {
    return false;
  }
  if (right >= fold.width + threshold) {
    return false;
  }
  return true;
};


/*
 * progressive load image
 */

progressiveLoad = function(el, settings) {
  var highQualityImage, highQualitySrc;
  if (!el.loaded && $(el).hasClass('progressive-load') && (highQualitySrc = el.getAttribute('data-high-quality'))) {
    highQualityImage = new Image();
    highQualityImage.style.display = 'none';
    $(highQualityImage).on('load', function() {
      if (el.nodeName === 'IMG') {
        el.src = highQualitySrc;
      } else {
        el.style.backgroundImage = "url('" + highQualitySrc + "')";
      }
      el.style['-webkit-filter'] = 'blur(0px)';
      el.style['filter'] = 'blur(0px)';
      return el.parentNode.removeChild(this);
    });
    highQualityImage.src = expChangeToWebp(highQualitySrc, settings);
    el.parentNode.appendChild(highQualityImage);
  }
  el.loaded = true;
};

(function(jQuery, window, document) {
  "use strict";
  return $.fn.lazyload = function(options) {
    var OPTS, allLazyImages, hasModernizr, initLazyLoading, loadImage, onScroll, requestTick, resizeTimer, settings, ticking;
    if (options == null) {
      options = {};
    }
    allLazyImages = this.get();
    resizeTimer = null;
    OPTS = {
      event: 'scroll.lazyload',
      threshold: 400,
      webp: false,
      skip_invisible: true,
      skip_initial_check: false,
      container: window,
      performantScroll: false,
      isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
      placeholder: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    };
    settings = _.assign({}, OPTS, options);
    if (settings.resetImageDimensions) {
      setTouchImageDimensions(allLazyImages);
      return;
    }
    ticking = false;

    /*
     * Global scroll handler
     */
    onScroll = function() {
      var fold, imagesNotLoaded, img, pos, positions, threshold;
      ticking = false;
      if (!settings.skip_invisible) {
        $(allLazyImages).trigger('appear');
        unbindLazyloaderEvent(settings);
        return;
      }
      imagesNotLoaded = getImagesToLoad(allLazyImages);
      if (!imagesNotLoaded.length) {
        unbindLazyloaderEvent(settings);
        return;
      }
      fold = getFold();
      allLazyImages = [];
      positions = getElementPositions(imagesNotLoaded);
      threshold = settings.threshold;
      while ((img = imagesNotLoaded.shift())) {
        pos = positions.shift();
        if (withinViewport(fold, pos, threshold)) {
          $(img).triggerHandler('appear');
        } else {
          allLazyImages.push(img);
        }
      }
    };

    /*
     * Image loading handler
     */
    loadImage = function() {
      var url, url2x;
      url = this.getAttribute('data-original');
      if (settings.isRetina && (url2x = this.getAttribute('data-original-2x'))) {
        url = url2x;
      }
      url = expChangeToWebp(url, settings);
      if (this.nodeName === 'IMG') {
        this.src = url;
      } else {
        this.style.backgroundImage = "url('" + url + "')";
      }
      progressiveLoad(this, settings);
    };

    /*
     * Asynchronous scroll handler
     */
    requestTick = function() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    };
    initLazyLoading = function(onScroll) {
      var images, img;
      if (resizeTimer === null) {
        $window.on('resize', function() {
          if (resizeTimer) {
            clearTimeout(resizeTimer);
          }
          return resizeTimer = setTimeout(onScroll, 100);
        });
      }
      images = allLazyImages.slice();
      while ((img = images.shift())) {
        if (img.nodeName === 'IMG' && img.src === '') {
          img.loaded = false;
          img.src = settings.placeholder;
        }
      }
      setTouchImageDimensions(allLazyImages);
      $(allLazyImages).one('appear', loadImage);
      fixiOS5(allLazyImages);
      window.removeEventListener('scroll', requestTick, {
        passive: true
      });
      window.addEventListener('scroll', requestTick, {
        passive: true
      });
      $(function() {
        settings = setWebpSetting(settings, options != null ? options.webp : void 0);
        if (!settings.skip_initial_check) {
          return requestTick();
        }
      });
      window.removeEventListener('load', setTouchImageDimensions(allLazyImages), {
        passive: true,
        once: true
      });
      return window.addEventListener('load', setTouchImageDimensions(allLazyImages), {
        passive: true,
        once: true
      });
    };
    if (options != null ? options.webp : void 0) {
      settings = setWebpSetting(settings, options.webp);
    }
    hasModernizr = window.Modernizr && typeof Modernizr.on === 'function';
    if (!settings.webp && hasModernizr && ((typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.webp : void 0) == null)) {
      return Modernizr.on('webp', function() {
        settings.webp = Modernizr.webp.valueOf();
        return initLazyLoading(onScroll);
      });
    } else {
      return initLazyLoading(onScroll);
    }
  };
})(jQuery, window, document);

module.exports = {
  getElementPositions: getElementPositions,
  getFold: getFold,
  getImagesToLoad: getImagesToLoad,
  getTouchDealCardHeight: getTouchDealCardHeight,
  setTouchImageDimensions: setTouchImageDimensions,
  setWebpSetting: setWebpSetting,
  withinViewport: withinViewport
};

//# sourceMappingURL=data:application/json;base64,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
